/**
* DevExpress Dashboard (custom-properties.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var serializable_model_1 = require("../serializable-model");
var _custom_property_validation_1 = require("./_custom-property-validation");
var CustomProperties = (function (_super) {
    __extends(CustomProperties, _super);
    function CustomProperties(json, serializer, info) {
        var _this = _super.call(this, json, serializer, info) || this;
        info.forEach(function (propertyInfo) {
            _this[propertyInfo.propertyName].subscribe(function (value) {
                propertyInfo.alwaysSerialize = value !== null && value !== undefined;
            });
        });
        _this.getInfo = function () { return info; };
        return _this;
    }
    CustomProperties.prototype._isKnownProperty = function (propertyName) {
        return !!this.getInfo().filter(function (i) { return i.propertyName === propertyName; })[0];
    };
    CustomProperties.prototype.getValue = function (propertyName) {
        if (this._isKnownProperty(propertyName)) {
            return this[propertyName].peek();
        }
        else {
            return this._model[propertyName];
        }
    };
    CustomProperties.prototype.setValue = function (propertyName, propertyValue) {
        _custom_property_validation_1.validateCustomPropertyName(propertyName);
        _custom_property_validation_1.validateCustomPropertyValueType(propertyName, propertyValue);
        if (this._isKnownProperty(propertyName)) {
            this[propertyName](propertyValue);
        }
        else {
            this._model[propertyName] = propertyValue;
        }
    };
    return CustomProperties;
}(serializable_model_1.SerializableModel));
exports.CustomProperties = CustomProperties;
